import { Link } from "react-router-dom";
import { friendLinks, siteNav } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 font-heading text-lg font-bold text-primary-700">
                明
              </span>
              <div>
                <p className="font-heading text-lg font-bold">佐佐木明希</p>
                <p className="text-[10px] font-label uppercase tracking-[0.25em] text-background-50/60">
                  Sasaki Aki Official
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-50/75">
              佐佐木明希官方资讯站，聚焦最新明星动态、影视作品与演艺资料，为关注她的观众提供清晰、准确的浏览体验。
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-label font-semibold uppercase tracking-wider text-background-50">
              <Link to="/" className="transition-colors hover:text-accent-300">
                站内导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {siteNav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-50/75 transition-colors hover:text-background-50"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-label font-semibold uppercase tracking-wider text-background-50">
              <Link to="/works" className="transition-colors hover:text-accent-300">
                友情链接
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {friendLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.url}
                    className="text-sm text-background-50/75 transition-colors hover:text-background-50"
                  >
                    {link.name}
                    <span className="ml-2 text-xs text-background-50/45">{link.desc}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-background-50/60">
            © {year} 佐佐木明希官网（演示站点）· 页面内容为示例数据，仅用于展示用途
          </p>
          <p className="text-xs leading-relaxed text-background-50/60">
            本站与任何真实人物、机构无关联，相关作品与信息均为虚构演示
          </p>
        </div>
      </div>
    </footer>
  );
}